/**
 * @fileoverview Utility for handling video backgrounds
 * @author david@blackairplane.com (David Leggett)
 * @copyright Black Airplane 2021
 */

import debounce from 'lodash/debounce';

class BackgroundVideo {
    constructor(el, config) {
        this.el = el;
        this.containerEl = el.parentElement;
        this.defaultConfig = {};
        this.config = Object.assign({}, this.defaultConfig, config);
        this.containerHeight = 0;
        this.containerWidth = 0;
        this.containerAspectRatio = 0;
        this.videoBaseHeight = 0;
        this.videoBaseWidth = 0;
        this.videoAspectRatio = 0;
        this.currentVideoHeight = 0;
        this.el.style.opacity = 0;
        this.el.style.transition = 'opacity 1000ms cubic-bezier(0.16, 1, 0.3, 1)';
        this.containerEl.style.overflow = 'hidden'
        this.started = false

        let handleDocumentLoaded = () => {
            this.el.load()

            this.el.addEventListener('loadeddata', (e) => {
                this.handleLoadedMetaData();
            })
        };

        document.addEventListener('DOMContentLoaded', handleDocumentLoaded);

        this.handleResize = () => {
            this.handleLoadedMetaData();
        };

        this.handleResizeDebounce = debounce(this.handleResize, 200);

        window.addEventListener('resize', this.handleResizeDebounce);

        setInterval(() => {
            this.handleResize()
        },500)
    }

    handleLoadedMetaData() {
        this.containerHeight = this.containerEl.offsetHeight;
        this.containerWidth = this.containerEl.offsetWidth;
        this.containerAspectRatio = this.containerHeight / this.containerWidth;
        this.videoBaseHeight = this.el.videoHeight;
        this.videoBaseWidth = this.el.videoWidth;
        this.videoAspectRatio = this.videoBaseHeight / this.videoBaseWidth;
        this.init();
    }

    init() {
        this.currentVideoHeight = this.containerWidth * this.videoAspectRatio;
        this.el.style.transform = 'translateX(0) translateY(0)';

        if (this.videoAspectRatio < this.containerAspectRatio) {
            this.el.style.width = this.containerHeight * (this.videoBaseWidth / this.videoBaseHeight) + 'px';
            this.el.style.height = this.containerHeight + 'px';
        } else {
            this.el.style.width = this.containerWidth + 'px';
            this.el.style.height = this.containerWidth * (this.videoBaseHeight / this.videoBaseWidth) + 'px';
        }

        // Make sure video is centered in frame
        let leftOffset = 0;
        let topOffset = 0;
        if(this.el.offsetWidth > this.containerWidth) {
            leftOffset = (this.el.offsetWidth - this.containerWidth) / 2;
        }

        if(this.el.offsetHeight > this.containerHeight) {
            topOffset = (this.el.offsetHeight - this.containerHeight) / 2;
        }

        this.el.style.transform = 'translateX(-' + leftOffset + 'px) translateY(-' + topOffset + 'px)';

        this.el.style.opacity = 1;

        if(!this.started) {
            this.el.play()
        }

        this.started = true
    }
}

export default BackgroundVideo
